import React, { useEffect } from 'react';

export default function BottomSheet({ open, onClose, title, children, height = 'auto' }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose && onClose(); };
    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;

  const sheetStyle = {
    ...styles.sheet,
    transform: open ? 'translateY(0)' : 'translateY(100%)',
    maxHeight: height === 'full' ? '94vh' : height === 'half' ? '60vh' : 'auto',
    height: height === 'full' ? '94vh' : 'auto',
  };

  return (
    <div style={styles.overlay} onClick={onClose} role="dialog" aria-modal="true">
      <div
        style={sheetStyle}
        onClick={(e) => e.stopPropagation()}
        role="document"
      >
        {(title || onClose) && (
          <header style={styles.header}>
            <h2 style={styles.title}>{title || ''}</h2>
            {onClose && (
              <button type="button" onClick={onClose} aria-label="Fermer" style={styles.closeBtn}>
                ✕
              </button>
            )}
          </header>
        )}
        <div style={styles.body}>{children}</div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(0, 0, 0, 0.45)',
    zIndex: 2000,
    display: 'flex',
    alignItems: 'flex-end',
    animation: 'revyoFade 200ms ease',
  },
  sheet: {
    width: '100%',
    background: '#FFFFFF',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    paddingBottom: 'env(safe-area-inset-bottom)',
    display: 'flex',
    flexDirection: 'column',
    transition: 'transform 250ms ease-out',
    boxShadow: '0 -8px 30px rgba(0,0,0,0.18)',
    overflow: 'hidden',
    touchAction: 'pan-y',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 20px 8px',
    borderBottom: '1px solid #EDEAE3',
  },
  title: {
    margin: 0,
    fontSize: 17,
    fontWeight: 700,
    color: '#1A1A1A',
    letterSpacing: '-0.01em',
  },
  closeBtn: {
    background: '#EDEAE3',
    border: 'none',
    width: 32,
    height: 32,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    fontSize: 14,
    color: '#1A1A1A',
    fontFamily: 'inherit',
  },
  body: {
    overflowY: 'auto',
    padding: 20,
    flex: 1,
    WebkitOverflowScrolling: 'touch',
  },
};
